import { render } from "./BalanceSettings.vue?vue&type=template&id=f39f44f2&scoped=true"
import script from "./BalanceSettings.vue?vue&type=script&lang=js"
export * from "./BalanceSettings.vue?vue&type=script&lang=js"

import "./BalanceSettings.vue?vue&type=style&index=0&id=f39f44f2&lang=scss&scoped=true"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f39f44f2"]])

export default __exports__